
var s = 0;



var scriptsList = ["//threadlogic.com/cdn/shop/t/222/assets/blueimp-jquery.ui.widget.js?v=11567595771158120061788895560", "//threadlogic.com/cdn/shop/t/222/assets/blueimp-jquery.iframe-transport.js?v=55610820773467321611788895559", "//threadlogic.com/cdn/shop/t/222/assets/blueimp-jquery.fileupload.js?v=165378899015369157421788895558", "//threadlogic.com/cdn/shop/t/222/assets/cloudinary-jquery-file-upload.js?v=182172400259282896161788895571", "//threadlogic.com/cdn/shop/t/222/assets/logo-upload.js?v=2&v=166949227588912353071788895647"]

function pf_append_js(scriptLocation, position = null){

  if(!position){
    var insertPosition = head;
  }
  else{  
    var insertPosition = document.getElementsByTagName("footer")[0];      
  }

  var theScript = document.createElement('script');
  theScript.setAttribute('src', scriptLocation); 
  insertPosition.appendChild(theScript);  

  return theScript;
}

function process_script(script){
  var scr = pf_append_js(script, 'footer')
  scr.onload = function(){    
    s++;
    if(scriptsList[s]){
      process_script(scriptsList[s])
    }
  }
}

function init_logo_script(){
    setTimeout(function(){
    	console.log('init logo scripts')      
      	process_script(scriptsList[0])
    }, 1000)
}
